import SearchFacets from './SearchFacets';

const searchFacetsConfig = {
  name: 'siteSearchFacets',
  class: SearchFacets,
  querySelector: {
    button: '.facets-search__showmore',
  },
  querySelectorAll: {
    facets: '.facets-search__groups',
  },
  options: {
    closedClass: 'facets-search__groups--closed',
  },
};

export default searchFacetsConfig;



// WEBPACK FOOTER //
// ./client/js/components/SearchFacets/searchFacetsConfig.js